<template>
  <b-card
    class="product-tile"
    @click="select"
  >
    <BCardImg :src="getImageUrl" @error="setAltImg($event)" img-top></BCardImg>
    <div class="product-name centered-block">{{product.name}}</div>
    <div class="price" :class="{'centered-block': !hasMemberDiscount}">
      <template v-if="hasMemberDiscount">
        <div class="membership-price-container">
          <div class="membership-price-tag"><span v-if="onSale">Sale</span><span v-else>Regular</span></div>
          <div class="membership-price" :class="{'original-price': session.has_membership}">
            {{product.price | currency(product.currency)}}
          </div>
        </div>
        <div class="membership-price-container">
          <div class="membership-price-tag">Member</div>
          <div class="membership-price">{{product.membership_price | currency(product.currency)}}</div>
        </div>
      </template>
      <template v-else-if="onSale">
        <div class="original-price">{{product.product.msrp | currency(product.currency)}}</div>
        <div class="sale-price">{{product.price | currency(product.currency)}}</div>
      </template>
      <template v-else>
        <div>{{ product.price | currency(product.currency) }}</div>
        <div>&nbsp;</div>
      </template>
    </div>
    <div v-if="onSale" class="new-onsale">Sale!</div>
  </b-card>
</template>

<script>
import {getCampaignProductImageUrl, setFallbackImageUrl} from '@/utils'

export default {
  name: 'RelatedProductTile',
  props: {
    product: Object,
    session: Object
  },
  computed: {
    getImageUrl: function() {
      return getCampaignProductImageUrl(this.product, 'medium')
    },
    onSale: function() {
      return this.product.product.msrp &&
        ((parseFloat(this.product.product.msrp) - parseFloat(this.product.price)) > Number.EPSILON)
    },
    hasMemberDiscount: function() {
      return this.product.membership_price !== null &&
        ((parseFloat(this.product.price) - parseFloat(this.product.membership_price)) > Number.EPSILON)
    }
  },
  methods: {
    select: function() {
      this.$router.push({name: 'product-details', params: {id: this.product.id, slug: this.product.slug}})
    },
    setAltImg: function(event) {
      setFallbackImageUrl(event, this.product, 'small', true)
    }
  }
}
</script>

<style scoped>
  .price {
    font-size: 18px;
    font-weight: bold;
  }
  .price span {
    margin: 0 5px;
  }
  .original-price {
    text-decoration: line-through;
    color: #ff0000;
    font-weight: normal;
  }

  .product-tile .product-name {
    font-size: 18px;
    min-height: 80px;
    text-align: center;
  }

  .product-tile .card-body {
    padding: .5rem 1.25rem;
  }

</style>
